import { GetterNames } from './keys'
import { PatientWithEventState } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { LOOK_BACK_DAYS_FOR_EVENTS, URGENT_EVENT_SEVERITY } from '@/utils/constants'
import moment from 'moment-timezone'
import { PatientWithEventsAttributes, PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'

export type FlatPatientWithEvents = FlatAPIData<PatientWithEventsAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.patientWithEvents]: (state: PatientWithEventState): FlatPatientWithEvents[] => {
    return state.patientWithEvents.map(flattenJsonApiResponse)
  },
  [GetterNames.patientWithRecentEvents]: (state, getters): FlatPatientWithEvents[] => {
    const lookBackTimestamp = moment()
      .add(-LOOK_BACK_DAYS_FOR_EVENTS, 'days')
      .valueOf()
    return getters[GetterNames.patientWithEvents]
      .map(patientWithEvent => {
        return {
          ...patientWithEvent,
          events: patientWithEvent.events
            .filter(event => event.eventTimestamp >= lookBackTimestamp)
            .sort((a, b) => b.eventTimestamp - a.eventTimestamp),
        }
      })
      .filter(patientWithEvents => patientWithEvents.events.length)
  },
  [GetterNames.patientWithUrgentEvents]: (state, getters): FlatPatientWithEvents[] => {
    return getters[GetterNames.patientWithRecentEvents]
      .filter(patientWithRecentEvents => {
        return patientWithRecentEvents.events.some((event: PatientWithEventsEvent) => {
          const numberEventSeverity = event.eventSeverity
          return numberEventSeverity >= URGENT_EVENT_SEVERITY
        })
      })
      .map(patientWithUrgentEvents => {
        return {
          ...patientWithUrgentEvents,
          events: patientWithUrgentEvents.events.filter(event => {
            const numberEventSeverity = event.eventSeverity
            return numberEventSeverity >= URGENT_EVENT_SEVERITY
          }),
        }
      })
  },
  [GetterNames.patientWithNewChangesEvents]: (state, getters): FlatPatientWithEvents[] => {
    return getters[GetterNames.patientWithRecentEvents].filter(patientWithRecentEvents => {
      const urgentEvent = patientWithRecentEvents.events.find((event: PatientWithEventsEvent) => {
        const numberEventSeverity = event.eventSeverity
        return numberEventSeverity >= URGENT_EVENT_SEVERITY
      })
      return !urgentEvent
    })
  },
}
